import { auth } from "../types"

export const registerWithMobile = (form, register_as, formName, navigate, gtag) => ({
    type: auth.GET_REGISTER_MOBILE_REQUEST,
    payload: { form, register_as, formName, navigate, gtag },
});

export const setErrorUndefined = () => ({
    type: auth.AUTH_ERROR_REQUEST,
    payload: undefined
})

export const signUpWithOtp = (formdata, otp, formName, navigate, setGtag) => ({
    type: auth.GET_SIGNUP_OTP_REQUEST,
    payload: { formdata, otp: parseInt(otp), logged_in_from: 'web', formName, navigate, setGtag },
});

export const getLoginOTP = ({ mobile, skip = true, bank_otp = 0, amount, source_url = false, formName, navigate, gtag }) => ({
    type: auth.GET_OTP_REQUEST,
    payload: { mobile, skip, bank_otp, amount, source_url, formName, navigate, gtag },
});

export const loginWithOTP = (mobile, otp, formName, navigate, setGtag) => ({
    type: auth.LOGIN_WITH_OTP_REQUEST,
    payload: { mobile, auth_otp: parseInt(otp), logged_in_from: 'web', skip: 'true', formName, navigate, setGtag },
});

export const signOutUser = (navigate) => ({ type: auth.SIGN_OUT_REQUEST, payload: { navigate } })

export const resendOtp = (mobile, register_as, resendFor) => ({
    type: auth.GET_RESEND_OTP_REQUEST,
    payload: { mobile, register_as, resendFor }
})

export const setTab = (tab) => (
    {
        type: auth.SET_TAB_SERVICE,
        payload: tab
    }
)